// Module
var code = "<div class=\"arrow-container center\"> <div class=\"arrow-steps clearfix\"> <div class=step> <small translate=user.summary.oldIban></small> <span ng-bind=\"vm.ticket.formValues.oldIban | iban:separator\"></span> </div> <div class=\"step current\"> <small translate=user.summary.newIban></small> <span ng-bind=\"vm.ticket.formValues.newIban | iban\"></span> </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/components/ticket/partials/ticket.ibanArrows.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;